<template>
	<div class="animated fadeIn">
		<b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer" no-body class="mb-3">
          <div slot="header" class="planheader">
            
            <!-- <b-row>
				<b-col class="col-2">
					<strong class="float-left mt-1">Add Plan</strong>
				</b-col>
				<b-col class="col-3 p-0">
                <span :class="{'active-tab': isActiveTab(0), 'inactive-tab': !isActiveTab(0)}" class="d-flex justify-content-center">
                  <a @click="setActiveTab(0)" class="text-center">With Plan</a>
                </span>
              </b-col>
              <b-col class="col-3 p-0">
                <span :class="{'active-tab': isActiveTab(1), 'inactive-tab': !isActiveTab(1)}" class="d-flex justify-content-center">
                  <a @click="setActiveTab(1)" class="text-center">Without Plan</a>
                </span>
              </b-col>
				<b-col class="text-right p-0">
					<b-button class="btn-md text-white cyanbtn" @click="downloadsamplecsv()">Download Sample CSV</b-button>
				</b-col>
			</b-row> -->

			<b-row>
				<b-col class="col-2">
				  <strong class="float-left mt-1">Add Plan</strong>
				</b-col>
				<b-col class="col-3 p-0">
				  <span 
					:class="{'active-tab': isActiveTab(0), 'inactive-tab': !isActiveTab(0)}" 
					class="d-flex justify-content-center" 
					@click="setActiveTab(0)"
				  >
					<a class="text-center">With Plan</a>
				  </span>
				</b-col>
				<b-col class="col-3 p-0">
				  <span 
					:class="{'active-tab': isActiveTab(1), 'inactive-tab': !isActiveTab(1)}" 
					class="d-flex justify-content-center" 
					@click="setActiveTab(1)"
				  >
					<a class="text-center">Without Plan</a>
				  </span>
				</b-col>
				<b-col class="text-right p-0">
				  <b-button class="btn-md text-white cyanbtn" @click="downloadsamplecsv()">Download Sample CSV</b-button>
				</b-col>
			  </b-row>
            
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-col>
      <div class="tab-panel" v-if="isActiveTab(0)">
        <b-row>
			<b-col sm="12">
				<b-card>
					<div class="formwrap">
						<b-row>
							<b-col sm="6">
								<b-row>
									<b-col sm="3">
										<label class="mt-1" for="">Warehouse ID</label>
									</b-col>
									<b-col sm="9">


										<b-select v-model="selectedhub">
											<option value="">-- Select Hub --</option>
											<option :value="hub.hubid" v-for="hub in hubItems" :key="hub.hubid">
												{{hub.hubname}} - {{hub.hubid}}
											</option>
										</b-select>


									</b-col>

								</b-row>
							</b-col>
							<b-col sm="6">
								<b-row>
									<b-col sm="3">
										<label class="mt-2" for="">Planning Date</label>
									</b-col>
									<b-col>
										<b-form-group>
											<v-date-picker v-model="selectDate" mode="single" input-class="dateInput"
												:available-dates="{ start: new Date(), end: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000)}">
											</v-date-picker>
										</b-form-group>
									</b-col>
								</b-row>
							</b-col>

							<b-col sm="6" class="mb-4">
								<b-row>
									<b-col sm="3">
										<label class="mt-1" for="">Vehicle number </label>
									</b-col>
									<b-col>

										<v-select v-model="selected_vehicleno" @change=selectsearchvehicle(selected_vehicleno)
											:options="vehicleitems.map(item => ({ value: item.vehicle_id, label: item.vehicle_no }))"
											placeholder="Select Vehicle number "></v-select>
									</b-col>
								</b-row>
							</b-col>
							<b-col sm="6">
								<b-row>
									<b-col sm="3">
										<label class="mt-1" for="">Plan Type</label>
									</b-col>
									<b-col>
										<b-select v-model="selectedplantype" @change="selectPlan(selectedplantype)"
											>
											<option value="">Select Plan Type</option>
											<option :value="val.value" :key="val.value" v-for="val in PlanType">{{val.type}}</option>
											
										</b-select>
									</b-col>
								</b-row>
							</b-col>

							<b-col sm="6" class="mb-4">
								<b-row>
									<b-col sm="3">
										<label class="mt-1" for="">Route</label>
									</b-col>
									<b-col>
										<b-select v-model="selectedroute" >
											<option value="">Select Route</option>
											<option value="local">Local</option>
											<option value="regional">Regional</option>
											<option value="national">National</option>
										</b-select>
									</b-col>
								</b-row>
							</b-col>
							
							<b-col sm="6" v-if="showHubDD" 
							v-for="(dropdown, index) in dropdowns"
							:key="index" class="mb-4"
							>
							<b-row>
							<b-col sm="3">
								<label class="mt-1">Select Hub {{ index + 1 }}</label>
							</b-col>
							<b-col>
								<v-select
								v-model="dropdown.selected"
								:options="optionsHub"
								label="label"
								:reduce="option => option"
								:clearable="true"
								@input="handleChange(index)"
								/>
							</b-col>
							</b-row>
							</b-col>


							<b-col sm="6" v-if="vehicleSizeDDFlag">
								<b-row>
									<b-col sm="3">
										<label class="mt-1" for="">Vehicle Size</label>
									</b-col>
									<b-col>
										<b-select v-model="selectedvehiclesize" >
											<option value="">Select Vehicle Size</option>
											<option :value="vehiclesize.key" v-for="vehiclesize in vehicleSizeList">{{vehiclesize.label}}
											</option>
										</b-select>
									</b-col>
								</b-row>
							</b-col>

							<b-col sm="6">
								<b-row>
									<b-col sm="3" class="pr-0">
										<label class="mt-1">Choose File</label><span style="color: red;">*</span>
									</b-col>
									<b-col>
										<b-form-group>
											<b-form-file col="2" type="file" ref="fileInput" v-model="file" :state="Boolean(file)"
												@change="selectcsvFiletoUpload($event)" placeholder="Upload CSV File" accept=".csv"
												required></b-form-file>
										</b-form-group>
									</b-col>
								</b-row>
							</b-col>
                            <b-col sm="6" v-if="vehicleSizeDDFlag">
								<b-row>
								<b-col sm="3" class="pr-0">
										<label class="mt-1">Start Date Of Bidding:</label><span style="color: red;">*</span>
									</b-col>
									<b-col >
								<b-form-group>
									<v-date-picker mode='single' input-class="dateInput"
									:available-dates='{ start: new Date(), end: null }'
									v-model='biddingStartOfDate'>
									</v-date-picker>
								</b-form-group>
								</b-col>
							</b-row>

							</b-col>
							<b-col sm="6" v-if="vehicleSizeDDFlag">

<b-row>
	<b-col sm="3" class="pr-0">
					<label class="mt-1">Bidding Start Time:</label><span style="color: red;">*</span>
				</b-col>
  <b-col cols="3">
	<b-form-select
	  v-model="form.effectiveStartHour"
	  :options="[{ value: '', text: 'HH', disabled: true }, ...hourOptions]"
	  required
	  class="mb-2 time-select"
	/>
  </b-col>
  <b-col cols="3">
	<b-form-select
	  v-model="form.effectiveStartMinute"
	  :options="[{ value: '', text: 'MM', disabled: true }, ...minuteOptions]"
	  required
	  class="mb-2 time-select"
	/>
  </b-col>
  <!-- <b-col cols="4">
	<b-form-select
	  v-model="form.effectiveStartPeriod"
	  :options="[{ value: '', text: 'AM/PM', disabled: true }, { value: 'AM', text: 'AM' }, { value: 'PM', text: 'PM' }]"
	  required
	  class="mb-2 time-select"
	/>
  </b-col> -->
</b-row>
</b-col>
							

							<b-col sm="6" v-if="vehicleSizeDDFlag">
								<b-row>
								<b-col sm="3" class="pr-0">
										<label class="mt-1">End Date Of Bidding:</label><span style="color: red;">*</span>
									</b-col>
									<b-col >
								<b-form-group>
									<v-date-picker mode='single' input-class="dateInput"
									:available-dates="{ start: biddingStartOfDate, end: null }"
									:disable-future="false"
									:disable-past="false"
									v-model='biddingEndOfDate'>
									</v-date-picker>
								</b-form-group>
								</b-col>
								</b-row>
								
							</b-col>
							<b-col sm="6" v-if="vehicleSizeDDFlag">

<b-row>
	<b-col sm="3" class="pr-0">
					<label class="mt-1">Bidding End Time:</label><span style="color: red;">*</span>
				</b-col>
  <b-col cols="3">
	<b-form-select
	  v-model="form.effectiveEndHour"
	  :options="[{ value: '', text: 'HH', disabled: true }, ...hourOptions]"
	  required
	  class="mb-2 time-select"
	/>
  </b-col>
  <b-col cols="3">
	<b-form-select
	  v-model="form.effectiveEndMinute"
	  :options="[{ value: '', text: 'MM', disabled: true }, ...minuteOptions]"
	  required
	  class="mb-2 time-select"
	/>
  </b-col>
  <!-- <b-col cols="4">
	<b-form-select
	  v-model="form.effectiveEndPeriod"
	  :options="[{ value: '', text: 'AM/PM', disabled: true }, { value: 'AM', text: 'AM' }, { value: 'PM', text: 'PM' }]"
	  required
	  class="mb-2 time-select"
	/>
  </b-col> -->
</b-row>
</b-col>

						</b-row>
						<hr>
						<b-row>
							<b-col class="mt-4">
								<b-button class="mr-2" variant="danger" v-if="!editplanid && errremark" @click="downloadErrCsv()">Download Plan</b-button>
								<b-button variant="danger" v-if="editplanid" @click="downloadPlan(editplanid)">Download Plan</b-button>
								<button class="float-right ml-2 btn btn-md btn-danger" @click="reset()">Cancel</button>
								<button v-if="updateplanflag" class="float-right btn-md btn btn-primary"
									@click="uploadPalnDetails(updateplanflag)">Update Plan</button>
								<button v-else class="float-right btn-md btn btn-primary" @click="uploadPalnDetails()">Submit</button>
							</b-col>
						</b-row>
						<b-row>
							<b-col>
								<div class="mt-3 text-danger" v-if="errremark">
									Remarks:- Please update the plan , click on download plan to fetch details of uploaded plan.
								</div>
							</b-col>
						</b-row>
					</div>

					<!-- invalid load id modal -->
					<div class="invalidloadmodal text-center" v-if="errorflag">
						<header>Caution!!</header>
						<div class="modal-body">
							<h6>Invalid Load IDs,please upload valid Load IDs!!</h6>
							<table class="" style="width:200px; text-align: left !important;">
								<tr>
									<th style="padding: 0 3px;">loadid</th>
								</tr>
								<tr v-for="invalidload in invalidloadids">
									<td style="padding:0">{{invalidload}}</td>
								</tr>
							</table>
							<b-button variant="danger" @click="closemodal()">Cancel</b-button>
						</div>
					</div>


					<!-- modal -->
					<div v-if="isModalVisible" class="invalidloadmodal text-center">
						<header>Caution!!</header>
						<div class="modal-body">
							<h6 v-if="activeModal === 'hub'">Please check below mentioned loads are of different Hub!!</h6>
							<h6 v-if="activeModal === 'route'">Please check below mentioned loads are of different Route!!</h6>
							<h6 v-if="activeModal === 'plan'">Load already Planned in another plan!</h6>
							<h6 v-if="activeModal === 'duplicate'">Duplicate Load IDs detected hence will remove duplicate!</h6>

							<table style="width:500px; margin:0; text-align: left !important;" v-if="showTable">

								<template v-if="activeModal === 'hub'">
									<tr>
										<th style="padding: 0 3px;">LoadID</th>
										<th style="padding: 0 3px;">Destination City</th>
										<th style="padding: 0 3px;">Destination State</th>
									</tr>
									<tr v-for="hubs in diffhub" :key="hubs.loadid">
										<td style="padding:0">{{hubs.loadid}}</td>
										<td style="padding:0">{{hubs.destinationcity}}</td>
										<td style="padding:0">{{hubs.destinationstate}}</td>
									</tr>
								</template>
							</table>

							<table style="width:500px; margin:0; text-align: left !important;" v-if="showTable">
								<template v-if="activeModal === 'route'">
									<tr>
										<th style="padding: 0 3px;">LoadID</th>
										<th style="padding: 0 3px;">Destination City</th>
										<th style="padding: 0 3px;">Destination State</th>
									</tr>
									<tr v-for="route in diffroute" :key="route.loadid">
										<td style="padding:0">{{route.loadid}}</td>
										<td style="padding:0">{{route.destinationcity}}</td>
										<td style="padding:0">{{route.destinationstate}}</td>
									</tr>
								</template>
							</table>
							<table style="width:500px; margin:0; text-align: left !important;" v-if="showTable">
								<template v-if="activeModal === 'plan'">
									<tr>
										<th style="padding: 0 3px;">LoadID</th>
										<th style="padding: 0 3px;">Plan ID</th>
										<th style="padding: 0 3px;">Vehicle number </th>
										<th style="padding: 0 3px;">Planning Date</th>
									</tr>
									<tr v-for="plan in diffplan" :key="plan.loadid">
										<td style="padding:0">{{plan.loadid}}</td>
										<td style="padding:0">{{plan.planid}}</td>
										<td style="padding:0">{{plan.vehicleno}}</td>
										<td style="padding:0">{{plan.plandate}}</td>
									</tr>
								</template>
							</table>

							<table style="width:500px; margin:0; text-align: left !important;" v-if="showTable">
								<template v-if="activeModal === 'duplicate'">
									<tr>
										<th style="padding: 0 3px;">LoadID</th>
									</tr>
									<tr v-for="load in duplicate" :key="load">
										<td style="padding:0;text-align: left !important;">{{load}}</td>
									</tr>
								</template>
							</table>
							<b-button class="mt-4" variant="primary" @click="proceed">Proceed</b-button>
							<b-button variant="danger" class="mt-4 ml-2" @click="cancel">Cancel</b-button>
						</div>
					</div>

				</b-card>
			</b-col>
		</b-row>                 
      </div>
      <div class="tab-panel" v-if="isActiveTab(1)">
        <b-row>
			<b-col sm="12">
				<b-card>
					<div class="formwrap">
						<b-row>
							<b-col sm="6">
								<b-row>
									<b-col sm="3">
										<label class="mt-1" for="">Warehouse ID</label>
									</b-col>
									<b-col sm="9">


										<b-select v-model="selectedhub">
											<option value="">-- Select Hub --</option>
											<option :value="hub.hubid" v-for="hub in hubItems" :key="hub.hubid">
												{{hub.hubname}} - {{hub.hubid}}
											</option>
										</b-select>


									</b-col>

								</b-row>
							</b-col>
							<b-col sm="6">
								<b-row>
									<b-col sm="3">
										<label class="mt-2" for="">Planning Date</label>
									</b-col>
									<b-col>
										<b-form-group>
											<v-date-picker v-model="selectDate" mode="single" input-class="dateInput"
												:available-dates="{ start: new Date(), end: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000)}">
											</v-date-picker>
										</b-form-group>
									</b-col>
								</b-row>
							</b-col>

							<b-col sm="6" class="mb-4">
								<b-row>
									<b-col sm="3">
										<label class="mt-1" for="">Vehicle number </label>
									</b-col>
									<b-col>

										<v-select v-model="selected_vehicleno" @change=selectsearchvehicle(selected_vehicleno)
											:options="vehicleitems.map(item => ({ value: item.vehicle_id, label: item.vehicle_no }))"
											placeholder="Select Vehicle number "></v-select>
									</b-col>
								</b-row>
							</b-col>
							<b-col sm="6">
								<b-row>
									<b-col sm="3">
										<label class="mt-1" for="">Plan Type</label>
									</b-col>
									<b-col>
										<b-select v-model="selectedplantype" @change="selectPlan(selectedplantype)"
											>
											<option value="">Select Plan Type</option>
											<option :value="val.value" :key="val.value" v-for="val in PlanType">{{val.type}}</option>
											
										</b-select>
									</b-col>
								</b-row>
							</b-col>
							<b-col sm="6" class="mb-4" v-if="selectedplantype === 'dd'">
								<b-row>
									<b-col sm="3">
										<label class="mt-1" for="">Enter Destination</label>
									</b-col>
									<b-col>
										<input type="text" v-model="destination_locations" class="form-control"
											placeholder="Enter Destination"></input>
									</b-col>
								</b-row>
							</b-col>
							

							<b-col sm="6" class="mb-4">
								<b-row>
									<b-col sm="3">
										<label class="mt-1" for="">Route</label>
									</b-col>
									<b-col>
										<b-select v-model="selectedroute" >
											<option value="">Select Route</option>
											<option value="local">Local</option>
											<option value="regional">Regional</option>
											<option value="national">National</option>
										</b-select>
									</b-col>
								</b-row>
							</b-col>
							
							<b-col sm="6" v-if="showHubDD" 
							v-for="(dropdown, index) in dropdowns"
							:key="index" class="mb-4"
							>
							<b-row>
							<b-col sm="3">
								<label class="mt-1">Select Hub {{ index + 1 }}</label>
							</b-col>
							<b-col>
								<v-select
								v-model="dropdown.selected"
								:options="optionsHub"
								label="label"
								:reduce="option => option"
								:clearable="true"
								@input="handleChange(index)"
								/>
							</b-col>
							</b-row>
							</b-col>
							<b-col sm="6" v-if="vehicleSizeDDFlag">
								<b-row>
									<b-col sm="3">
										<label class="mt-1" for="">Vehicle Size</label>
									</b-col>
									<b-col>
										<b-select v-model="selectedvehiclesize" >
											<option value="">Select Vehicle Size</option>
											<option :value="vehiclesize.key" v-for="vehiclesize in vehicleSizeList">{{vehiclesize.label}}
											</option>
										</b-select>
									</b-col>
								</b-row>
							</b-col>

                            <b-col sm="6" v-if="vehicleSizeDDFlag">
								<b-row>
								<b-col sm="3" class="pr-0">
										<label class="mt-1">Comment:</label><span style="color: red;">*</span>
									</b-col>
									<b-col>
                                <b-form-group>                           
                  <b-form-textarea v-model.trim="adhoc_remark" style="height:100px" placeholder="add comment"></b-form-textarea>                                           
                </b-form-group>
				</b-col>
				</b-row>
                            </b-col>
							<b-col sm="6" v-if="vehicleSizeDDFlag">
								<b-row>
								<b-col sm="3" class="pr-0">
										<label class="mt-1">Start Date Of Bidding:</label><span style="color: red;">*</span>
									</b-col>
									<b-col >
                    <b-form-group>
                        <v-date-picker mode='single' input-class="dateInput"
                        :available-dates='{ start: new Date(), end: null }'
                        v-model='biddingStartOfDate'>
                        </v-date-picker>
                    </b-form-group>
									</b-col>
								</b-row>
								
                </b-col>
				<b-col sm="6" v-if="vehicleSizeDDFlag">

					<b-row>
						<b-col sm="3" class="pr-0">
										<label class="mt-1">Bidding Start Time:</label><span style="color: red;">*</span>
									</b-col>
                      <b-col cols="3">
                        <b-form-select
                          v-model="form.effectiveStartHour"
                          :options="[{ value: '', text: 'HH', disabled: true }, ...hourOptions]"
                          required
                          class="mb-2 time-select"
                        />
                      </b-col>
                      <b-col cols="3">
                        <b-form-select
                          v-model="form.effectiveStartMinute"
                          :options="[{ value: '', text: 'MM', disabled: true }, ...minuteOptions]"
                          required
                          class="mb-2 time-select"
                        />
                      </b-col>
                      <!-- <b-col cols="4">
                        <b-form-select
                          v-model="form.effectiveStartPeriod"
                          :options="[{ value: '', text: 'AM/PM', disabled: true }, { value: 'AM', text: 'AM' }, { value: 'PM', text: 'PM' }]"
                          required
                          class="mb-2 time-select"
                        />
                      </b-col> -->
                    </b-row>
				</b-col>

                <b-col sm="6" v-if="vehicleSizeDDFlag">
					<b-row>
								<b-col sm="3" class="pr-0">
										<label class="mt-1">End Date Of Bidding:</label><span style="color: red;">*</span>
									</b-col>
									<b-col >
                    <b-form-group>
                        <v-date-picker mode='single' input-class="dateInput"
                        :available-dates="{ start: biddingStartOfDate, end: null }"
                        :disable-future="false"
                        :disable-past="false"
                        v-model='biddingEndOfDate'>
                        </v-date-picker>
                    </b-form-group>
									</b-col>
								</b-row>
								
                </b-col>
				<b-col sm="6" v-if="vehicleSizeDDFlag">

<b-row>
	<b-col sm="3" class="pr-0">
					<label class="mt-1">Bidding End Time:</label><span style="color: red;">*</span>
				</b-col>
  <b-col cols="3">
	<b-form-select
	  v-model="form.effectiveEndHour"
	  :options="[{ value: '', text: 'HH', disabled: true }, ...hourOptions]"
	  required
	  class="mb-2 time-select"
	/>
  </b-col>
  <b-col cols="3">
	<b-form-select
	  v-model="form.effectiveEndMinute"
	  :options="[{ value: '', text: 'MM', disabled: true }, ...minuteOptions]"
	  required
	  class="mb-2 time-select"
	/>
  </b-col>
  <!-- <b-col cols="4">
	<b-form-select
	  v-model="form.effectiveEndPeriod"
	  :options="[{ value: '', text: 'AM/PM', disabled: true }, { value: 'AM', text: 'AM' }, { value: 'PM', text: 'PM' }]"
	  required
	  class="mb-2 time-select"
	/>
  </b-col> -->
</b-row>
</b-col>
                <b-col sm="6" v-if="vehicleSizeDDFlag">
					<b-row>
								<b-col sm="3" class="pr-0">
										<label class="mt-1">No Of Loads:</label><span style="color: red;">*</span>
									</b-col>
									<b-col>
                                <b-form-group>                           
                  <b-input type="text" v-model.trim="no_of_loads" placeholder="Enter No Of Loads"></b-input>                                           
                </b-form-group>
									</b-col>
					</b-row>
                            </b-col>
						</b-row>
						<hr>
						<b-row>
							<b-col class="mt-4">
								<b-button class="mr-2" variant="danger" v-if="!editplanid && errremark" @click="downloadErrCsv()">Download Plan</b-button>
								<b-button variant="danger" v-if="editplanid" @click="downloadPlan(editplanid)">Download Plan</b-button>
								<button class="float-right ml-2 btn btn-md btn-danger" @click="reset()">Cancel</button>
								<button v-if="updateplanflag" class="float-right btn-md btn btn-primary"
									@click="uploadPalnDetails(updateplanflag)">Update Plan</button>
								<button v-else class="float-right btn-md btn btn-primary" @click="uploadPalnDetails()">Submit</button>
							</b-col>
						</b-row>
						<b-row>
							<b-col>
								<div class="mt-3 text-danger" v-if="errremark">
									Remarks:- Please update the plan , click on download plan to fetch details of uploaded plan.
								</div>
							</b-col>
						</b-row>
					</div>

					<!-- invalid load id modal -->
					<div class="invalidloadmodal text-center" v-if="errorflag">
						<header>Caution!!</header>
						<div class="modal-body">
							<h6>Invalid Load IDs,please upload valid Load IDs!!</h6>
							<table class="" style="width:200px; text-align: left !important;">
								<tr>
									<th style="padding: 0 3px;">loadid</th>
								</tr>
								<tr v-for="invalidload in invalidloadids">
									<td style="padding:0">{{invalidload}}</td>
								</tr>
							</table>
							<b-button variant="danger" @click="closemodal()">Cancel</b-button>
						</div>
					</div>


					<!-- modal -->
					<div v-if="isModalVisible" class="invalidloadmodal text-center">
						<header>Caution!!</header>
						<div class="modal-body">
							<h6 v-if="activeModal === 'hub'">Please check below mentioned loads are of different Hub!!</h6>
							<h6 v-if="activeModal === 'route'">Please check below mentioned loads are of different Route!!</h6>
							<h6 v-if="activeModal === 'plan'">Load already Planned in another plan!</h6>
							<h6 v-if="activeModal === 'duplicate'">Duplicate Load IDs detected hence will remove duplicate!</h6>

							<table style="width:500px; margin:0; text-align: left !important;" v-if="showTable">

								<template v-if="activeModal === 'hub'">
									<tr>
										<th style="padding: 0 3px;">LoadID</th>
										<th style="padding: 0 3px;">Destination City</th>
										<th style="padding: 0 3px;">Destination State</th>
									</tr>
									<tr v-for="hubs in diffhub" :key="hubs.loadid">
										<td style="padding:0">{{hubs.loadid}}</td>
										<td style="padding:0">{{hubs.destinationcity}}</td>
										<td style="padding:0">{{hubs.destinationstate}}</td>
									</tr>
								</template>
							</table>

							<table style="width:500px; margin:0; text-align: left !important;" v-if="showTable">
								<template v-if="activeModal === 'route'">
									<tr>
										<th style="padding: 0 3px;">LoadID</th>
										<th style="padding: 0 3px;">Destination City</th>
										<th style="padding: 0 3px;">Destination State</th>
									</tr>
									<tr v-for="route in diffroute" :key="route.loadid">
										<td style="padding:0">{{route.loadid}}</td>
										<td style="padding:0">{{route.destinationcity}}</td>
										<td style="padding:0">{{route.destinationstate}}</td>
									</tr>
								</template>
							</table>
							<table style="width:500px; margin:0; text-align: left !important;" v-if="showTable">
								<template v-if="activeModal === 'plan'">
									<tr>
										<th style="padding: 0 3px;">LoadID</th>
										<th style="padding: 0 3px;">Plan ID</th>
										<th style="padding: 0 3px;">Vehicle number </th>
										<th style="padding: 0 3px;">Planning Date</th>
									</tr>
									<tr v-for="plan in diffplan" :key="plan.loadid">
										<td style="padding:0">{{plan.loadid}}</td>
										<td style="padding:0">{{plan.planid}}</td>
										<td style="padding:0">{{plan.vehicleno}}</td>
										<td style="padding:0">{{plan.plandate}}</td>
									</tr>
								</template>
							</table>

							<table style="width:500px; margin:0; text-align: left !important;" v-if="showTable">
								<template v-if="activeModal === 'duplicate'">
									<tr>
										<th style="padding: 0 3px;">LoadID</th>
									</tr>
									<tr v-for="load in duplicate" :key="load">
										<td style="padding:0;text-align: left !important;">{{load}}</td>
									</tr>
								</template>
							</table>
						
							<b-button class="mt-4" variant="primary" @click="proceed">Proceed</b-button>
							<b-button variant="danger" class="mt-4 ml-2" @click="cancel">Cancel</b-button>
						</div>
					</div>

				</b-card>
			</b-col>
		</b-row>
      </div>
    </b-col>
	</div>
</template>
<script>
	import CONSTANTS from "@/utils/constants";
	import { EventBus } from "./event-bus.js";
	import ExcelJS from 'exceljs';
	import Utils from "@/utils";
	import auth from "@/utils/auth";

	export default {
		data: function () {
			return {
				selectedOption: null, // Initial selected value
				selectedVehicle: '',
				isBusy: false,
				planUploadedType: null,
				hub_name: "",
				selected_vehicleno: 'NA',
				selectcsvFile: "",
				selectFiletype: "",
				file: "",
				selectDateFrom: new Date(),
				selectDateTo: new Date(),
				vehicleitems: [],
				vehiclenumber: [],
				csvUrl: "",
				csvUrlvar: "",
				plan_id: 1,
				options: [{
					text: "Hub Inward",
					value: "Hub Inward"
				}, {
					text: "Hub Inward And Direct Dispatch Plan",
					value: "Hub Inward And Direct Dispatch Plan",
				}, {
					text: "Direct Dispatch And Hub Inward Plan",
					value: "Direct Dispatch And Hub Inward Plan",
				}, {
					text: "Hub Outward",
					value: "Hub Outward"
				}, {
					text: "Hub Outward And Direct Dispatch Plan",
					value: "Hub Outward And Direct Dispatch Plan",
				}, {
					text: "Direct Dispatch Plan",
					value: "Direct Dispatch Plan"
				}, {
					text: "Client Pickup",
					value: "Client Pickup"
				}],
				items: [],
				fields: [{
					key: "plan_id",
					label: "Sr. no",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "created_date",
					label: "Plan UPloaded Date",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "plan_type",
					label: "Plan Type",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "uploaded_by",
					label: "Plan Uploaded By",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "vehicleno",
					label: "Manifested Vehicle number ",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "update_vehicle_no",
					label: "Plan Vehicle number ",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "hub_name",
					label: "HUB",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "loadcount",
					label: "Load Count",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "boxcount",
					label: "Box Count",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "planeditedby",
					label: "Plan Edited By",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "planedited_date",
					label: "Plan Edited on",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "download",
					label: "Download Ewaybill",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "view",
					label: "View/Edit",
					sortable: true,
					sortDirection: "desc",
				}],
				file: '',
				accessBody: [],
				isReadOnly: false,
				valueWH: [],
				fieldWH: { text: 'hubname', value: 'hubid' },
				optionsWH: [],
				WHData: [],
				selectedplantype: '',
				PlanType: [
					{
						type: 'Direct Delivery(DD)',
						value: 'dd'
					},
					{
						type: 'Line Haul(LH)',
						value: 'lh'
					},
					{
						type: 'National Line Haul(NLH)',
						value: 'nlh'
					}
				],
				selectedroute: '',
				selectedhub1: '',
				selectedvehiclesize: '',
				hubItems: [],
				selectedhub: '',
				showSelectAll: true,
				vehicleSizeDDFlag: false,
				selectDate: null,
				dropdowns: [{ selected: '' }],
				showHubDD: false,
				hubArray: '',
				uploadedby: '',
				errorflag: false,
				errremark: false,
				invalidloadids: [],
				InvalidLoadResponse: [],
				vehicleSizeList: [],
				selectedHubs: '',
				diffhub: [],
				diffhubflag: false,
				diffroute: [],
				diffrouteflag: false,
				diffplan: [],
				diffplanflag: false,
				duplicate: [],
				duplicateflag: false,
				activeModal: '',
				isModalVisible: false,
				currentArrayIndex: 0,
				arrays: [],
				showTable: false, // New flag to control table visibility
				finalcall: false,
				uploadResponse: [],
				editplanid: '',
				planLogData: '',
				up_vehicle_no: '',
				optionsHub:[],
                activeTab: 0,
                biddingStartOfDate: null,
                biddingEndOfDate: null,
				no_of_loads: null,
				adhoc_remark: null,
				destination_locations: '',
				form: {
					effectiveStartHour: '',
					effectiveStartMinute: '',
					effectiveEndHour: '',
					effectiveEndMinute: '',
				},
				hourOptions: Array.from({ length: 24 }, (_, i) => {
					const value = String(i + 1).padStart(2, '0');
					return { value, text: value };
				}),
				minuteOptions: Array.from({ length: 60 }, (_, i) => {
					const value = String(i).padStart(2, '0');
					return { value, text: value };
				}),
				};
		},
		mounted() {
    if (this.$route.query.delivery_location_without_plan == 'true') {
        console.log(this.$route.query, 'this.$route.querythis.$route.query22@@');
        this.activeTab = 0; // Set the active tab to "With Plan"
    } else {
        this.activeTab = 1; // Set the active tab to "Without Plan"
    }
},
		created: async function () {
			var userdata = localStorage.getItem("userData");
			var userInfo = JSON.parse(userdata);
			this.userType = userInfo.user_type;
			this.uploadedby = userInfo.sysemailid;
			this.user_id = userInfo.sysusermasterid;
			this.accessBody = userInfo.body;
			this.editplanid = ''
			this.editplanid = this.$route.query.planid
			this.updateplanflag = this.$route.query.editflag
            console.log(this.updateplanflag, "updateplanflag");  
			this.ischeckbodyvalidation();
			this.getAllPlanListing();
			this.getVehicleSize();
			await this.vehicleListing();
			if (this.editplanid) {
				await this.getdetailbyplanid(this.editplanid);
			}
			this.showWHlist();
			this.hubListing();
			if(	this.selected_vehicleno == "NA"){
				this.vehicleSizeDDFlag=true;
			}
			
			// this.isActiveTab(this.activeTab)
			
		
            
		},
		computed: {
		},

		methods: {
            isActiveTab(id) {
				console.log(id, 'id is activeaaaa');
				this.selected_vehicleno == "NA"

				if(	this.selected_vehicleno == "NA"){
					this.vehicleSizeDDFlag=true;
				}
			return this.activeTab === id; // Check if the tab is active
			},
			resetValues() {
				this.selectedhub = '';
				this.selectDate = null;
				this.selected_vehicleno = '';
				this.selectedplantype = '';
				this.selectedroute = '';
				this.dropdowns = [];
				this.selectedvehiclesize = '';
				this.file = null;
				this.selectFromDate = null;
				this.selectToDate = null;
				this.vehicleSizeDDFlag = false;
				this.showHubDD = false;
				this.biddingStartOfDate = null;
				this.biddingEndOfDate = null;
				this.no_of_loads = null;
				this.adhoc_remark = null;
				this.selected_vehicleno == "NA";
				this.destination_locations = '';
				this.form.effectiveStartHour = '';
				this.form.effectiveStartMinute = '';
				this.form.effectiveEndHour = '';
				this.form.effectiveEndMinute = '';
				// Reset other properties as needed
			},
			setActiveTab(id) {
				this.resetValues(); // Reset all values when the tab changes
				this.selected_vehicleno = "NA";
				this.activeTab = id; // Update the active tab

			},
            
			downloadPlan(planid) {
				let sendObj = {
					planid: planid
				}
				this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/downloadPlancsv`, sendObj, { responseType: 'blob' })
					.then((response) => {
						const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', `Plan-${planid}.csv`);
						document.body.appendChild(link);
						link.click();
						link.remove();
					}).catch((ex) => {
						console.log("error", ex);
					});
			},


			closemodal() {
				this.errorflag = !this.errorflag
			},

			checkArrays() {
				// Filter out empty arrays and prepare for display
				this.arrays = [
					{ data: this.diffhub, modal: 'hub' },
					{ data: this.diffroute, modal: 'route' },
					{ data: this.diffplan, modal: 'plan' },
					{ data: this.duplicate, modal: 'duplicate' },
				].filter(array => array.data.length > 0); // Keep only those with data

				if (this.arrays.length > 0) {
					this.currentArrayIndex = 0; // Reset index
					this.activeModal = this.arrays[this.currentArrayIndex].modal; // Set active modal
					this.showTable = true; // Show table for the first modal
					this.isModalVisible = true; // Show modal
				}
			},

			proceed() {
				// Hide the current table before proceeding
				this.showTable = false;

				this.currentArrayIndex++;
				if (this.currentArrayIndex < this.arrays.length) {
					// Update active modal and show the next table
					this.activeModal = this.arrays[this.currentArrayIndex].modal;
					this.showTable = true; // Show the next table
				} else {
					this.finalApiCall(); // Call final API when all tables are shown
					this.isModalVisible = false; // Close modal
				}
			},

			cancel() {
				document.getElementById("overlay").style.display = "none";
				this.isModalVisible = false; // Close modal
				this.currentArrayIndex = 0; // Reset index for next time
				this.showTable = false; // Reset table visibility

				if (this.uploadResponse && this.uploadResponse.length) {
					this.errremark = true
					this.InvalidLoadResponse = this.uploadResponse[0].body.loadjson
					console.log("uploadResponse", this.InvalidLoadResponse)
				}

			},

			finalApiCall() {
				console.log("Final API call triggered.");
				this.finalcall = true

				if (this.updateplanflag) {
					this.uploadPalnDetails(this.updateplanflag)
				} else {
					this.uploadPalnDetails()
				}

				// Example API call logic:
				// axios.post('/api/endpoint', { /* data */ })
				//   .then(response => { /* handle response */ })
				//   .catch(error => { /* handle error */ });
			},

			setData(result) {
				this.diffhub = result.body.diffhub || []; // Ensure it's an array
				this.diffroute = result.body.diffroute || []; // Ensure it's an array
				this.diffplan = result.body.indiffplan || []; // Ensure it's an array
				this.duplicate = result.body.duplicate || []; // Ensure it's an array
				this.checkArrays(); // Check arrays after setting data
			},


			// handleChange(index) {
			// 	console.log("enter in handleChange", index)
			// 	// Check if the current dropdown is the last one
			// 	if (index === this.dropdowns.length - 1 && this.dropdowns[index].selected.key) {
			// 		// Add a new dropdown with a unique `selected` value
			// 		this.dropdowns.push({ selected: '' });
			// 		console.log("drop down values....", this.dropdowns)

			// 		const values = this.dropdowns.map(dropdown => dropdown.selected.key);
			// 		// Join values into a comma-separated string
			// 		console.log("values>>>>>>>>>>>>>>>>>>>>>>>...",values)
			// 		this.hubArray = values.join(',');
			// 		console.log("drop down values22222222....", this.hubArray)
			// 	}
			// },
			handleChange(index) {
    const selectedValue = this.dropdowns[index].selected;

    // Add a new dropdown only if the last one is selected and it's not the last dropdown
    if (
      selectedValue &&
      selectedValue.key &&
      index === this.dropdowns.length - 1
    ) {
      this.dropdowns.push({ selected: '' });
    }

    // Handle clearing the dropdown: shift dropdowns properly
    if (selectedValue === null || selectedValue === '') {
      // Shift dropdown values after clearing
      this.dropdowns.splice(index, 1); // Remove the current dropdown with null value
    }

    // Rebuild hubArray with valid keys (no undefined/null/empty values)
    const validKeys = this.dropdowns
      .map(d => d.selected && d.selected.key)
      .filter(key => key !== undefined && key !== null && key !== '');

    this.hubArray = validKeys.join(',');

    console.log('Current dropdowns:', this.dropdowns);
    console.log('HubArray:', this.hubArray);
  },




			// closemodal() {
			// 	this.errorflag = !this.errorflag
			// },

			ischeckbodyvalidation() {
				for (let i = 0; i < this.accessBody.length; i++) {
					const element = this.accessBody[i];

					// if (element.title=='Bulk Reallocation' && element.isReadonly==true && this.route_id=='normal') {
					//   this.isReadOnly=true
					// }
					if (element.child) {
						for (let j = 0; j < element.child.length; j++) {
							const k = element.child[j];
							if (k.title == 'Bulk Reallocation' && k.isReadonly == true) {
								this.isReadOnly = true
							}
						}
					}
				}
				console.log(" this.isReadOnly", this.isReadOnly)
			},

			//vehicle size
			getVehicleSize() {
				this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getVehicleSizeList`).then((result) => {
					console.log("Vehicle Size resultttttt@@@@@@", result)
					this.vehicleSizeList = result.body.returnvalue
					console.log("Vehicle Size resultttttt@@@@@@22222222", this.vehicleSizeList)
				}).catch((ex) => {
					console.log("error", ex);
				});
			},

			//vehicle no
			async vehicleListing() {
				try {
					console.log("enter in vehicle fun")
					var userdata = localStorage.getItem("userData");
					var userInfo = JSON.parse(userdata);
					let obj = {
						sysusermasterid: `${userInfo.sysusermasterid}`,
						usertype: "",
						isactive: "1",
						vehicle_type: "bulkreallocate",
					};
					console.log("obj", obj);

					let result = await this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getVehicleListing`, obj)

					if (result && result.body) {
						let resp = []
						resp = result.body
						resp.unshift({ vehicle_no: 'NA', vehicle_id: 'NA', })
						this.vehicleitems = resp
						
						console.log("vehicle list resp", this.vehicleitems)
						// for (let i = 0; i < this.vehicleitems.length; i++) {
						// 	this.vehiclenumber.push(this.vehicleitems[i].vehicle_id);
						// }
						// this.vehiclenumber.unshift('NA')
						// this.vehicleitems.unshift('NA')
					}

				} catch (error) {
					console.error("Error fetching plan details:", error);
				}
			},

			//on change vehicle no
			selectsearchvehicle(vehicleno) {

				if (vehicleno == null) {
					this.selectedvehiclesize = ''
					this.vehicleSizeDDFlag = false
					this.$fire({
						text: "Please Select Vehicle No",
						type: "error",
						timer: 30000,
					});
				}


				if (vehicleno == 'NA') {
					this.vehicleSizeDDFlag = true
				} else if (vehicleno.value == 'NA') {
					this.vehicleSizeDDFlag = true
				} else {
					this.vehicleSizeDDFlag = false
				}
			},

			//on play type hub will shown
			selectPlan(plan) {
				console.log("seleced plan @@@@ ", plan)
				if (plan == 'lh' || plan == 'nlh') {
					this.showHubDD = true
					this.dropdowns = [{ selected: null }]; // Example: One dropdown
				}
				else {
					this.showHubDD = false
				}
			},

			//hub list
			hubListing() {
				var userdata = localStorage.getItem("userData");
				var userInfo = JSON.parse(userdata);
				const obj = {
					sysusermasterid: `${userInfo.sysusermasterid}`,
					usertype: `${userInfo.user_type}`,
				}
				console.log("objlist", obj)
				this.$http
					.post(
						`${CONSTANTS.MIGRATION_API_URL}/getAllHubListing`, obj).then(result => {
							if (result.body.returnmsg === "Successful") {
								this.hubItems = result.body.returnvalue;
								console.log("aaaaaaaa", this.hubItems);
								for(let j = 0; j < this.hubItems.length; j++) {
									let hub = {
										label: this.hubItems[j].hubname + " - " + this.hubItems[j].hubid,
										key: this.hubItems[j].hubid,
									}
									this.optionsHub.push(hub);
								}

							} else {
								this.hubItems = [];
								this.optionsHub =[];
							}
						}).catch(ex => {
							console.log("error", ex);
						});
			},

			//wh list
			showWHlist: function () {

				var userdata = localStorage.getItem('userData')
				var userInfo = JSON.parse(userdata)

				var csvObj = {};
				// console.log("JJJJJ", csvObj);
				// return false;
				this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getWarehouselisting`, csvObj)
					.then(result => {
						if (result.body.returnmsg === 'Successful') {
							this.optionsWH = [];
							this.WHData = result.body.returnvalue;
							// console.log("HHHHHHH", this.WHData)
							for (let j = 0; j < this.WHData.length; j++) {
								let WH = {
									name: this.WHData[j].warehouseid + " - " + this.WHData[j].warehousename,
									id: this.WHData[j].warehouseid,
								}
								// console.log("hjjjjj", WH.name);
								this.optionsWH.push(WH);
								// console.log("optionsWH", this.optionsWH);
							}
						} else {
							this.WHData = result.body.returnvalue;
						}
					})
					.catch(ex => {
						console.log("error-----", ex);
					});
			},
			downloadErrorCsv() {
				var userdata = localStorage.getItem("userData");

				var userInfo = JSON.parse(userdata);
				this.loadurl = `${CONSTANTS.MIGRATION_API_URL}/downloadErrorCsv?plan_id=` + this.plan_id

			},

			//download sample csv
			downloadsamplecsv() {
				let filedata = [
					{
						'loadid': '',
            			'unloadsequence': ''
					}
				]
				// filedata.push(
				// 	{
				// 		'loadid': 'L90XZ3744753651',
				// 		'unloadsequence': 1
				// 	},
				// 	{
				// 		'loadid': 'L07SF6447854177',
				// 		'unloadsequence': 1
				// 	},
				// 	{
				// 		'loadid': 'L28PD3821919425',
				// 		'unloadsequence': 1
				// 	},
				// 	{
				// 		'loadid': 'L85FT9033820507',
				// 		'unloadsequence': 2
				// 	}
				// )
				this.ConvertJsonToCsv(filedata, 'Sample_File_CSV')
			},

			ConvertJsonToCsv(reportResult, reportName) {
				const json = reportResult
				const header = Object.keys(json[0])
				let csv = json.map(row => header.map(fieldName => JSON.stringify(row[fieldName] || '')))
				csv.unshift(header)
				csv = csv.join('\r\n')
				this.downloadCsv(csv, reportName)
			},

			downloadCsv(csv, reportName) {
				var csvData = csv
				const fileName = reportName
				var blob = new Blob([csvData], {
					type: 'application/csv;charset=utf-8;'
				})
				var link = document.createElement('a')
				var csvUrl = URL.createObjectURL(blob)
				link.href = csvUrl
				link.style = 'visibility:hidden'
				link.download = fileName + '.csv'
				document.body.appendChild(link)
				link.click()
				document.body.removeChild(link)
			},



			downloadplanedcsv() {

				this.csvUrl = `${CONSTANTS.MIGRATION_API_URL}/getSampleCSVForPlanType?plan_type=`
				this.csvUrlvar = this.csvUrl;
				console.log(this.csvUrlvar);
			},

			// validateForm(scope) {
			// 	this.$validator.validateAll(scope).then((result) => {
			// 		if (result) {
			// 			this.uploadPalnDetails();
			// 		}
			// 	});
			// },


			selectcsvFiletoUpload(event) {
				this.selectcsvFile = event.target.files[0];
				// this.imgname= this.selectedFiles.name;
				console.log("HHH", this.selectcsvFile);
				this.selectFiletype = event.target.files[0].type;
				console.log("selectFiletype", this.selectFiletype);
			},


        // format Date function
        // formatDate: function(date) {
        //     var d = new Date(date),
        //         month = "" + (d.getMonth() + 1),
        //         day = "" + d.getDate(),
        //         year = d.getFullYear();
        //     if (month.length < 2) month = "0" + month;
        //     if (day.length < 2) day = "0" + day;
        //     return [year, month, day].join("-")
        // },
		formatDate(date) {
  const d = new Date(date);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
},

			uploadPalnDetails: function (updateflag) {
                var biddingStartOfDate = this.biddingStartOfDate
  ? this.formatDate(this.biddingStartOfDate)
  : null;

var biddingEndOfDate = this.biddingEndOfDate
  ? this.formatDate(this.biddingEndOfDate)
  : null;

const {
  effectiveStartHour,
  effectiveStartMinute,
  effectiveEndHour,
  effectiveEndMinute,
} = this.form;

let biddingStartDateTime = null;
let biddingEndDateTime = null;

if (biddingStartOfDate && effectiveStartHour && effectiveStartMinute) {
  biddingStartDateTime = `${biddingStartOfDate} ${effectiveStartHour}:${effectiveStartMinute}:00`;
}

if (biddingEndOfDate && effectiveEndHour && effectiveEndMinute) {
  biddingEndDateTime = `${biddingEndOfDate} ${effectiveEndHour}:${effectiveEndMinute}:00`;
}

console.log(biddingStartDateTime, 'biddingStartDateTime');
console.log(biddingEndDateTime, 'biddingEndDateTime');
// return false;
                let plansource = ''
                if (this.activeTab == 0) {
					this.selected_vehicleno && this.selected_vehicleno == 'NA' ?  plansource = 'with-plan-adhoc' : plansource = 'with-plan-regular'
            
                } else {
					this.selected_vehicleno && this.selected_vehicleno == 'NA' ?  plansource = 'without-plan-adhoc' : plansource = 'without-plan-regular'
                     // plansource = 'without-plan'
                }
                console.log(biddingStartOfDate, 'biddingStartOfDate')
                console.log(biddingEndOfDate, 'biddingEndOfDate')
                console.log("enter in uploadPalnDetails", plansource);
                // return  false;
				document.getElementById("overlay").style.display = "block";
				var userdata = localStorage.getItem("userData");
				var userInfo = JSON.parse(userdata);
				// console.log("this.selected_vehicleno", this.selected_vehicleno.value)
				if (this.selectedhub == "" || this.selectedhub == null) {
					this.$fire({
						text: "Please Select Warehouse ID",
						type: "error",
						timer: 30000,
					});
					document.getElementById("overlay").style.display = "none";
					return false;
				}
				if (this.selectDate == "" || this.selectDate == null) {
					this.$fire({
						text: "Please Select Plan Date",
						type: "error",
						timer: 30000,
					});
					document.getElementById("overlay").style.display = "none";
					return false;
				}
				if (this.selected_vehicleno == "" || this.selected_vehicleno == null) {
					this.$fire({
						text: "Please Select Vehicle Number",
						type: "error",
						timer: 30000,
					});
					document.getElementById("overlay").style.display = "none";
					return false;
				}

				if (this.selectedplantype == "" || this.selectedplantype == null) {
					this.$fire({
						text: "Please Select Plan Type",
						type: "error",
						timer: 30000,
					});
					document.getElementById("overlay").style.display = "none";
					return false;
				}

				if ((this.selectedplantype == "lh" || this.selectedplantype == "nlh") && !this.hubArray.length) {
					this.$fire({
						text: "Please Select At least One Hub",
						type: "error",
						timer: 30000,
					});
					document.getElementById("overlay").style.display = "none";
					return false;
				}

				if (this.selectedroute == "" || this.selectedroute == null) {
					this.$fire({
						text: "Please Select Route",
						type: "error",
						timer: 30000,
					});
					document.getElementById("overlay").style.display = "none";
					return false;
				}
				if (this.selected_vehicleno == "NA" && this.selectedvehiclesize == "") {
					this.$fire({
						text: "Please Select Vehicle Size",
						type: "error",
						timer: 30000,
					});
					document.getElementById("overlay").style.display = "none";
					return false;
				}

				// if (this.selected_vehicleno == "NA" && (this.biddingStartOfDate == null || this.biddingEndOfDate == null)) {
				// 	this.$fire({
				// 		text: "Please Select Start And Date End Date Of Bidding",
				// 		type: "error",
				// 		timer: 30000,
				// 	});
				// 	document.getElementById("overlay").style.display = "none";
				// 	return false;
				// }

							if (this.selected_vehicleno == "NA") {
			if (
				this.biddingStartOfDate == null ||
				this.biddingEndOfDate == null ||
				this.form.effectiveStartHour == '' ||
				this.form.effectiveStartMinute == '' ||
				this.form.effectiveEndHour == '' ||
				this.form.effectiveEndMinute == ''
			) {
				this.$fire({
				text: "Please Select Start and End Date and Fill All Time Fields",
				type: "error",
				timer: 30000,
				});
				document.getElementById("overlay").style.display = "none";
				return false;
			}
			}

				console.log("plansource>>>>>>>>>>>>>", plansource,this.no_of_loads)
				if ( plansource == 'without-plan' && (this.no_of_loads=='' || this.no_of_loads==null || this.no_of_loads=='null')) {
					this.$fire({
						text: "Please Enter No Of Loads",
						type: "error",
						timer: 30000,
					});
					document.getElementById("overlay").style.display = "none";
					return false;
				}



				if (this.user_id == "") {
					this.$fire({
						text: "Please Assign User ID",
						type: "error",
						timer: 30000,
					});
					document.getElementById("overlay").style.display = "none";
					return false;
				}

				if (this.activeTab == 1 && this.selectFiletype != "text/csv") {

				
						let obj = {}

						
						obj.originhub = this.selectedhub;

						if (updateflag) {
							obj.vehicleid=this.up_vehicle_no
						} else {
							if (this.selected_vehicleno == 'NA') {
								obj.vehicleid = null
							} else if (this.selected_vehicleno.value == 'NA') {
								obj.vehicleid = null
							} else if (typeof this.selected_vehicleno === 'object') {
								obj.vehicleid = this.selected_vehicleno.value
							} else {
								obj.vehicleid = this.selected_vehicleno
							}

						}

						let formattedDate = ''

						if (typeof (this.selectDate) == 'string') {
							let dateString = this.selectDate; // "20/10/2024"
							let parts = dateString.split("/"); // ["20", "10", "2024"]
							let dateObject = new Date(parts[2], parts[1] - 1, parts[0]);
							formattedDate = `${dateObject.getFullYear()}-${String(dateObject.getMonth() + 1).padStart(2, '0')}-${String(dateObject.getDate()).padStart(2, '0')}`;
						} else {
							formattedDate = `${this.selectDate.getFullYear()}-${String(this.selectDate.getMonth() + 1).padStart(2, '0')}-${String(this.selectDate.getDate()).padStart(2, '0')}`;
						}


						console.log(this.dropdowns, "dropdowns");
						const dropdownValues = this.dropdowns.map(dropdown => dropdown.selected);
						console.log(dropdownValues, 'dropdownValues');
						const filteredLabels = dropdownValues
						.filter(item => item && item.label).map(item => item.label);

						console.log(filteredLabels, 'filteredLabels');
						const slicedLabels = filteredLabels.map(label => label.split('-')[0].trim());
						console.log(slicedLabels, 'slicedLabels');

						obj.plandate = formattedDate;
						obj.plantype = this.selectedplantype
						obj.vehiclesize = this.selectedvehiclesize;
						obj.hubs = this.hubArray
						obj.route = this.selectedroute
						obj.sysusermasterid = this.user_id
						obj.uploadedby = this.uploadedby
						obj.bidding_start_date = biddingStartDateTime ? biddingStartDateTime : null
						obj.bidding_end_date = biddingEndDateTime ? biddingEndDateTime : null
						obj.plan_source = plansource
						obj.no_of_loads = this.no_of_loads ? this.no_of_loads : null
						obj.adhoc_remark = this.adhoc_remark ? this.adhoc_remark : null
						obj.destination_locations= this.destination_locations ? this.destination_locations : slicedLabels.toString();
						// if (this.finalcall) {
						// 	obj.proceed = 1
						// }
						// console.log("data appended", data)
						// console.log("object payload", obj);
						// return false;
						let planAPI = ''
						if (updateflag) {
							obj.planid = this.editplanid
							planAPI = `${CONSTANTS.MIGRATION_API_URL}/updateRFQPlanWithoutCSV`
							// data.append("planid", this.editplanid)
						} else {
							planAPI = `${CONSTANTS.MIGRATION_API_URL}/addRFQPlanWithoutCSV`
						}

						// console.log("object payload", obj)
						this.$http.post(`${planAPI}`, obj).then((result) => {
							// this.invalidloadids = result.invalidloadids
							console.log("YYY", result);
							document.getElementById("overlay").style.display = "none";
							
							if (plansource == 'with-plan') {
								this.activeTab = 0;
							} else {
								this.activeTab = 1 ;
							}
							if (result.body.returnmsg == 'Successful') {
								this.resetValues();
								this.$fire({
									text: "Plan Uploaded Successfully",
									type: "success",
									timer: 30000,
								});
							}

							else {
								this.$fire({
										text:result.body.returnvalue,
										type: "error",
										timer: 30000,
									});
							}
							// if (result.body.returnmsg == 'UnSuccessful') {
							// 	if (result.body.returnvalue == 'Hub Not Found') {
							// 		this.$fire({
							// 			text: "Hub Mapping Not Found.",
							// 			type: "error",
							// 			timer: 30000,
							// 		});
							// 	} else {
							// 		this.$fire({
							// 			text: "Error Occured, Plan Not Created",
							// 			type: "error",
							// 			timer: 30000,
							// 		});

							// 	}
							// }


						}
						).catch((ex) => {
							console.log("error", ex);
						});




















				} else {

					console.log("=================>>>>>>>>>>>>>>>>")
					if (this.selectFiletype == "text/csv") {

						console.log("date before format", typeof this.selectDate, this.selectDate)

						let formattedDate = ''
						// let dateParts = this.selectDate.split('/');
						// let outputDate = new Date(dateParts[2], dateParts[0] - 1, dateParts[1]);
						// let formattedDate = ''
						// formattedDate = `${outputDate.getFullYear()}-${String(outputDate.getMonth() + 1).padStart(2, '0')}-${String(outputDate.getDate()).padStart(2, '0')}`;

						// let year = this.selectDate.getFullYear();
						// let month = String(this.selectDate.getMonth() + 1).padStart(2, '0');
						// let day = String(this.selectDate.getDate()).padStart(2, '0');
						// let formattedDate = ''
						// formattedDate = `${year}-${month}-${day}`;

						if (typeof (this.selectDate) == 'string') {
							let dateString = this.selectDate; // "20/10/2024"
							let parts = dateString.split("/"); // ["20", "10", "2024"]
							let dateObject = new Date(parts[2], parts[1] - 1, parts[0]);
							formattedDate = `${dateObject.getFullYear()}-${String(dateObject.getMonth() + 1).padStart(2, '0')}-${String(dateObject.getDate()).padStart(2, '0')}`;
						} else {
							formattedDate = `${this.selectDate.getFullYear()}-${String(this.selectDate.getMonth() + 1).padStart(2, '0')}-${String(this.selectDate.getDate()).padStart(2, '0')}`;
						}


						// let formattedDate = `${this.selectDate.getFullYear()}-${String(this.selectDate.getMonth() + 1).padStart(2, '0')}-${String(this.selectDate.getDate()).padStart(2, '0')}`;

						console.log("formated date", formattedDate)

						let data = new FormData();

						data.append("file", this.selectcsvFile);
						data.append("originhub", this.selectedhub);

						if (updateflag) {
							data.append("vehicleid", this.up_vehicle_no)
						} else {
							if (this.selected_vehicleno == 'NA') {
								data.append("vehicleid", null)
							} else if (this.selected_vehicleno.value == 'NA') {
								data.append("vehicleid", null)
							} else if (typeof this.selected_vehicleno === 'object') {
								console.log("while append vehicle id 1", this.selected_vehicleno)
								data.append("vehicleid", this.selected_vehicleno.value)
							} else {
								console.log("while append vehicle id 2", this.selected_vehicleno)
								data.append("vehicleid", this.selected_vehicleno)
							}

						}



						data.append("plandate", formattedDate);
						data.append("plantype", this.selectedplantype)
						data.append("vehiclesize", this.selectedvehiclesize);
						data.append("hubs", this.hubArray)
						data.append("route", this.selectedroute)
						data.append("sysusermasterid", this.user_id)
						data.append("uploadedby", this.uploadedby)
						data.append("bidding_start_date", biddingStartDateTime ? biddingStartDateTime : null)
						data.append("bidding_end_date", biddingEndDateTime ? biddingEndDateTime : null)
						data.append("plan_source", plansource)
						if (this.finalcall) {
							data.append("proceed", 1)
						}
						console.log("data appended", data)

						// return false;

						let planAPI = ''
						if (updateflag) {
							planAPI = `${CONSTANTS.MIGRATION_API_URL}/updateRFQPlan`
							data.append("planid", this.editplanid)
						} else {
							planAPI = `${CONSTANTS.MIGRATION_API_URL}/addRFQPlan`
						}

						// console.log("object payload", obj)
						this.$http.post(`${planAPI}`, data, {
							header: {
								"Content-Type": "multipart/form-data",
							},
						}).then((result) => {
							// this.invalidloadids = result.invalidloadids
							console.log("YYY", result);
							document.getElementById("overlay").style.display = "none";
							this.resultMsg = result.returnmsg;
							this.uploadResponse.push(result)
							console.log("upload response", this.uploadResponse)
							if (result.body.invalidloadids && result.body.invalidloadids.length) {
								document.getElementById("overlay").style.display = "block";
								this.errorflag = true
								this.errremark = true
								this.invalidloadids = result.body.invalidloadids
								document.getElementById("overlay").style.display = "none";
								console.log("load ids invalid", this.invalidloadids)
								this.InvalidLoadResponse = result.body.loadjson
								console.log("invalide response", this.InvalidLoadResponse)

								// this.$fire({
								// 	text: result.returnvalue,
								// 	type: "error",
								// 	timer: 30000,
								// });
							}

							if (result.body.returnmsg == 'UnSuccessful' && result.body.returnvalue == 'Error in uploading s3 file!') {
								this.$fire({
									text: 'Unable to upload file due to Error',
									type: "error",
									timer: 30000,
								});
							}

							if (result.body.returnmsg == 'UnSuccessful' && result.body.returnvalue == 'unloadsequence is not correct') {
								this.$fire({
									text: 'Unload Sequence Is Not Correct',
									type: "error",
									timer: 30000,
								});
							}

							if (result.body.returnmsg == 'UnSuccessful' && result.body.returnvalue == 'conditions not matched for nlh') {
								this.$fire({
									text: 'conditions not matched for nlh',
									type: "error",
									timer: 30000,
								});
							}


							if (result.body.returnvalue == 'serviceability warnings' && result.body.diffhub && result.body.diffhub.length) {
								document.getElementById("overlay").style.display = "block";
								this.setData(result)
								// this.diffhub = result.body.diffhub
							}
							if (result.body.returnvalue == 'serviceability warnings' && result.body.diffroute && result.body.diffroute.length) {
								document.getElementById("overlay").style.display = "block";
								this.setData(result)
								// this.diffroute = result.body.diffroute
							}

							if (result.body.returnvalue == 'serviceability warnings' && result.body.indiffplan && result.body.indiffplan.length) {
								document.getElementById("overlay").style.display = "block";
								// this.diffplan = result.body.indiffplan
								this.setData(result)
							}

							if (result.body.returnvalue == 'serviceability warnings' && result.body.duplicate && result.body.duplicate.length) {
								document.getElementById("overlay").style.display = "block";
								// this.duplicate = result.body.duplicate
								this.setData(result)
							}
							if (result.body.returnmsg == 'Successful' && result.body.returnvalue && result.body.returnvalue.id) {
								console.log("return value", result.body.returnvalue.id)
								this.$fire({
									text: "Plan Uploaded Successfully",
									type: "success",
									timer: 30000,
								});
								this.$refs.fileInput.value = null
								this.reset()
							}

							if (result.body.returnmsg == 'Successful' && result.body.returnvalue && result.body.returnvalue == 'plan updated') {
								console.log("return value", result.body.returnvalue)

								// this.planLogData = result.body.logactivity
								// console.log("plan log data", this.planLogData)

								setTimeout(() => {
									this.planLogData = result.body.logactivity
									this.$router.push({
										path: '/newPlanListing',
										query: { logData: this.planLogData }
									});
								}, 1000); // Simulate a delay

								this.$fire({
									text: "Plan Updated Successfully",
									type: "success",
									timer: 30000,
								});
								this.editplanid = ''
								this.updateplanflag = false
								this.$refs.fileInput.value = null
								this.reset()
							}
							if (result.body.returnmsg == 'UnSuccessful') {
								if (result.body.returnvalue == 'Hub Not Found') {
									this.$fire({
										text: "Hub Mapping Not Found.",
										type: "error",
										timer: 30000,
									});
								} else {
									this.$fire({
										text: "Error Occured, Plan Not Created",
										type: "error",
										timer: 30000,
									});

								}
							}


						}
						).catch((ex) => {
							console.log("error", ex);
						});
					}
					else {
						document.getElementById("overlay").style.display = "none";
						this.$fire({
							text: "Please Upload CSV File Only",
							type: "error",
							timer: 30000,
						});
					}
				}
			},

			async downloadErrCsv() {
				// this.ConvertJsonToCsv(this.InvalidLoadResponse, 'Sample_File_CSV')
				await this.ConvertJsonToExcel(this.InvalidLoadResponse, 'Sample_File_Excel');
				// this.reset()
				this.errorflag = false
				this.errremark = false
			},

			async ConvertJsonToExcel(reportResult, reportName) {
				const workbook = new ExcelJS.Workbook();
				const worksheet = workbook.addWorksheet('Sheet1');

				// Add header
				const header = Object.keys(reportResult[0]);
				worksheet.addRow(header);

				// Add data rows with conditional formatting
				reportResult.forEach(row => {
					const newRow = worksheet.addRow(Object.values(row));

					// Check the condition for highlighting
					if (row.remark === "invalid load" || row.remark === "Different Hub") {
						newRow.eachCell((cell) => {
							cell.fill = {
								type: 'pattern',
								pattern: 'solid',
								fgColor: { argb: 'FFFF0000' }, // Red color
							};
						});
					}
				});

				// Export the Excel file
				const buffer = await workbook.xlsx.writeBuffer();
				const blob = new Blob([buffer], { type: 'application/octet-stream' });
				const url = window.URL.createObjectURL(blob);

				const link = document.createElement('a');
				link.href = url;
				link.download = reportName + '.xlsx';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				window.URL.revokeObjectURL(url);
			},


			formatDate: function (date) {
				var d = new Date(date),
					month = "" + (d.getMonth() + 1),
					day = "" + d.getDate(),
					year = d.getFullYear();
				if (month.length < 2) month = "0" + month;
				if (day.length < 2) day = "0" + day;
				return [year, month, day].join("-");
			},

			searchPlan: function () {
				var fromdate = this.selectDateFrom != null ? this.formatDate(this.selectDateFrom) : "";
				var formatdateto = this.selectDateTo != null ? this.formatDate(this.selectDateTo) : "";
				this.isBusy = true;
				const obj = {
					startdate: `${fromdate}`,
					enddate: `${formatdateto}`,
					vehicleno: this.selected_vehicleno,
				};
				if (formatdateto < fromdate) {
					this.$fire({
						text: "To date need to be grater than From date",
						type: "warning",
						timer: 30000,
					});
					this.isBusy = false;
					return false;
				}
				this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllPlanListing`, obj).then((result) => {
					this.isBusy = false;
					if (result.body.returnmsg === "Successful") {
						this.items = result.body.returnvalue;
					} else {
						//  this.showdata = []
						this.items = [];
						// this.totalRows = 0;
					}
				}).catch((ex) => {
					console.log("error-----", ex);
				});
			},

			rowClass(item, type) {
				if (item) {
					if (item.update_vehicle_no != null) {
						if (item.vehicleno != item.update_vehicle_no) {
							return 'table-danger'
						}
					}
				}
			},

			getAllPlanListing: function () {
				const obj = {
					startdate: "",
					enddate: "",
					vehicleno: "",
				};
				this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllPlanListing`, obj).then((result) => {
					if (result.body.returnmsg === "Successful") {
						this.items = result.body.returnvalue;
					} else {
						//  this.showdata = []
						this.items = [];
						// this.totalRows = 0;
					}
				}).catch((ex) => {
					console.log("error-----", ex);
				});
			},

			//planid received from edit plan new plan upload page
			async getdetailbyplanid(planid) {
				try {

					// var queryString = "?planid=" + planid;
					let sendObj = {
						planid: planid
					}

					const result = await this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getRFQPlanMasterDetails`, sendObj);

					if (result) {

						// await this.vehicleListing(); // Ensure vehicleListing completes
						// console.log("vehicle list !!@@##$$", this.vehicleitems)

						let a = []
						a = this.vehicleSizeList.filter((e) => {
							if (e.label === result.body.returnvalue.vehiclesize) {
								return e
							}
						})
						this.selectedvehiclesize = a.length ? a[0].key : ''
						this.selectDate = result.body.returnvalue.planningdate
						this.biddingStartOfDate = result.body.returnvalue.bidding_start_date
						this.biddingEndOfDate = result.body.returnvalue.bidding_end_date
						this.destination_locations = result.body.returnvalue.delivery_location_without_plan ? result.body.returnvalue.delivery_location_without_plan : '';

						this.selectedhub = result.body.returnvalue.originhub
						this.selected_vehicleno = result.body.returnvalue.vehicle_id


						if (this.updateplanflag && this.selected_vehicleno !== null) {
							this.up_vehicle_no = this.selected_vehicleno

							const vehicle = this.vehicleitems.find(e => e.vehicle_id === this.selected_vehicleno);

							if (vehicle) {
								this.selected_vehicleno = vehicle.vehicle_no;
								console.log("Updated selected vehicle number:", this.selected_vehicleno);
							} else {
								console.log("No matching vehicle found.");
							}
						} else {
							if (this.updateplanflag && this.selected_vehicleno == null) {
								this.selected_vehicleno = 'NA'
								this.up_vehicle_no = null
								this.selectsearchvehicle(this.selected_vehicleno)
							}

						}


						let plantype = ''
						plantype = result.body.returnvalue.plantype
						this.selectPlan(plantype)
						this.selectedplantype = plantype

						this.selectedroute = result.body.returnvalue.route
						this.user_id = this.user_id
						this.user_id = this.user_id

						let destination = []
						destination = result.body.returnvalue.destinationhubdata
						this.dropdowns = destination.map(dest => ({ selected: dest.hubid }));
						console.log("hub arrays result of edit", this.dropdowns)

						const values = this.dropdowns.map(dropdown => dropdown.selected.key);
						// Join values into a comma-separated string
						this.hubArray = values.join(',');
						console.log("hub arrays after edit", this.hubArray)
						this.handleChange()
					}
				} catch (error) {
					console.error("Error fetching plan details:", error);
				}
			},
			reset() {
				if(this.editplanid){
					this.file = ''
					this.$refs.fileInput.value = null
				}
				else{
					// this.selectcsvFile = ''
					this.file = ''
					this.$refs.fileInput.value = null
					this.selectedhub = ''
					this.selected_vehicleno = 'NA'
					this.selectsearchvehicle(this.selected_vehicleno)
					this.selectDate = ''
					this.selectedplantype = ''
					this.selectedvehiclesize = ''
					this.dropdowns = [{ selected: '' }]// Reset to initial state
					this.hubArray = '' // Reset hubArray
					this.showHubDD = false
					this.selectedroute = ''
					// this.uploadedby = ''
					this.InvalidLoadResponse = []
					this.errremark = false
					this.biddingStartOfDate = null;
				this.biddingEndOfDate = null;
					// window.location.reload();
				}
			},



		},
	};
</script>
<style  scoped>
	.planheader a {
		display: block;
		line-height: 35px;
		padding: 0 10px;
		border-radius: 5px;

		&:hover {
			text-decoration: none;
		}
	}

	.cyanbtn {
		background: cyan;
		color: #000 !important;
		border: none;
		border-radius: 8px;

		&:hover {
			background: cyan;
		}
	}

	.graybutton {
		background: #777;
		letter-spacing: 0.5px;
		appearance: none;
		-webkit-appearance: none;
		border-radius: 8px;

		&:hover {
			background: #777;
		}
	}

	.orangebutton {
		background: #f0a910;
		border: none;
		-webkit-appearance: none;
		appearance: none;
		font-size: 16px;

		&:hover {
			background: #f0a910;
		}
	}

	.tabwrapper {
		.tab-content {
			border: none;
			padding: 5px;
		}
	}

	.tabs ul.nav-pills {
		border: none !important;
		margin: 10px 0;

		li {
			width: 50%;

			a {
				border-radius: 8px;
				color: #fff;
				font-weight: bold;
				text-align: center;
				letter-spacing: 1px;
				font-size: 16px;
				background: #777;

			}

			/* // &:first-child {
			// 	a {
			// 		background: #777;
			// 	}
			// }

			// &:last-child {
			// 	a {
			// 		background: #f0a910;
			// 	}
			// } */
		}
	}

	.col.disabled {
		pointer-events: none !important;

		div input {
			background: #e4e7ea;
		}
	}

	.invalidloadmodal {
		width: auto;
		max-height: 300px;
		overflow: auto;
		position: absolute;
		transform: translate(-50%, -50%);
		background: #fff;
		left: 50%;
		top: 50%;
		z-index: 999;
		border: 1px solid #ccc;

		header {
			border-bottom: 1px solid #ccc;
			color: #f0a910;
			font-size: 18px;
			line-height: normal;
			padding: 5px 0;
			font-weight: bold;
		}
	}
    .active-tab {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #007bff;
  cursor: pointer;
  /* border-radius: 5px;
  padding: 10px; */
}

.inactive-tab {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f8f9fa;
  cursor: pointer;
  /* border-radius: 5px;
  padding: 10px; */
}

.active-tab b-button {
  color: white;
}

.inactive-tab b-button {
  color: #6c757d;
}
</style>